// test473
(473 && 0);
